import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {fetchGlobalTags, updateTag} from "../../store/tag-slice";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";

const TagUpdate = () => {
    const navigator = useNavigate();
    const dispatch = useDispatch();

    const {
        globalTags,
        selectedData: selectedGlobalTags,
        fetchGlobalTagsStatus,
        updateStatus,
        error
    } = useSelector(state => state.tag);

    useEffect(() => {
        if (updateStatus === "success") {
            navigator("..");
        }
    }, [updateStatus, navigator]);

    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        dispatch(fetchGlobalTags(userRole));
    }, [dispatch, userRole]);

    const [selectedTags, setSelectedTags] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    useEffect(() => {
        if (globalTags.length > 0 && selectedGlobalTags.length > 0) {
            setSelectedTags(selectedGlobalTags);
        }
    }, [globalTags, selectedGlobalTags]);

    useEffect(() => {
        setSelectAll(selectedTags.length === globalTags.length);
    }, [selectedTags, globalTags]);

    const handleCheckboxChange = (tagId) => {
        setSelectedTags(prevState =>
            prevState.includes(tagId)
                ? prevState.filter(id => id !== tagId)
                : [...prevState, tagId]
        );
    };

    const handleSelectAllChange = () => {
        if (selectAll) {
            setSelectedTags([]);
        } else {
            setSelectedTags(globalTags.map(tag => tag.id));
        }
        setSelectAll(!selectAll);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        dispatch(updateTag({...userRole, tag: selectedTags}));
    };

    return (
        <>
            <SubHeader title="Update Tag">
                <Button to="../" className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchGlobalTagsStatus === "loading" && <p>Loading...</p>}
                {fetchGlobalTagsStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {updateStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchGlobalTagsStatus === "success" && (
                    <form onSubmit={handleSubmit}>
                            <div className="form-check py-1">
                                <input
                                    type="checkbox"
                                    id="selectAll"
                                    className="form-check-input"
                                    checked={selectAll}
                                    onChange={handleSelectAllChange}
                                />
                                <label htmlFor="selectAll" className="form-check-label">
                                    Select / Unselect All
                                </label>
                            </div>
                        <div className="row">
                            {globalTags.map(tag => (
                                <div key={tag.id} className="col-md-4 col-lg-3">
                                    <div className="form-check py-1">
                                        <input
                                            type="checkbox"
                                            value={tag.id}
                                            id={tag.id}
                                            checked={selectedTags.includes(tag.id)}
                                            onChange={() => handleCheckboxChange(tag.id)}
                                            className="form-check-input"
                                        />
                                        <label htmlFor={tag.id} className="form-check-label">
                                            {tag.name}
                                        </label>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <button type="submit" className="btn btn-primary mt-3">
                            Submit
                        </button>
                    </form>
                )}
            </div>
        </>
    );
};

export default TagUpdate;
